export enum CinemaWsMethods {
  SeatStatusChanged = 'SeatStatusChanged'
}
